import { render } from "./guidePage.vue?vue&type=template&id=676a43f0"
import script from "./guidePage.vue?vue&type=script&lang=js"
export * from "./guidePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__